import { Routes } from '../api-routes'
import { AlertDTO } from '../dtos/alert'
import { getPath, setP } from './helpers'

export namespace AlertsRoutes {
  export namespace get {
    export function call(p = setP(['organizationId', 'asCaseWorkerId'])) {
      return getPath(p, { suffix: Routes.Alerts })
    }
    export type Response = { alerts: AlertDTO[] }
  }

  export namespace patchOne {
    export function call(
      p = setP(['organizationId', 'beneficiaryId', 'alertId']),
    ) {
      return getPath(p)
    }
    export type Request = { fields: Pick<AlertDTO, 'status'> }
    export type Response = { alert: AlertDTO }
  }
}
